/* Restaurare foto — utilitare comune: derulare, apariții la scroll, analiză, bara lipită.
   Celelalte fișiere (rf-restore, rf-compare, rf-merge, rf-demo, rf-configurator) se
   înregistrează aici cu RF.register(), ca să pornească și în editorul de teme, când o
   secțiune este reîncărcată. */
(function () {
  'use strict';
  if (window.RF && window.RF.ready) return;

  var RF = (window.RF = window.RF || {});
  RF.ready = true;
  RF.cfg = window.RF_CONFIG || {};
  RF.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------- derulare */
  // Horizon derulează în .page-wrapper pe ecrane mari și în fereastră pe telefon.
  RF.scroller = function () {
    var el = document.querySelector('.page-wrapper');
    if (el && el.scrollHeight > el.clientHeight + 4) {
      var oy = getComputedStyle(el).overflowY;
      if (oy === 'auto' || oy === 'scroll') return el;
    }
    return null;
  };
  RF.scrollTop = function () {
    var s = RF.scroller();
    return s ? s.scrollTop : window.scrollY || document.documentElement.scrollTop;
  };
  RF.onScroll = function (fn) {
    document.addEventListener('scroll', fn, { capture: true, passive: true });
  };
  RF.scrollTo = function (el) {
    if (!el) return;
    el.scrollIntoView({ behavior: RF.reducedMotion ? 'auto' : 'smooth', block: 'start' });
  };

  /* -------------------------------------------------------------- analiză */
  // Un singur loc din care pleacă toate evenimentele. Se pot asculta cu
  //   document.addEventListener('rf:track', e => ...)
  // și ajung singure la Meta Pixel, TikTok Pixel, GA4 și Shopify, dacă există pe pagină.
  var STANDARD = {
    add_to_cart: { fb: 'AddToCart', tt: 'AddToCart', ga: 'add_to_cart' },
    checkout_start: { fb: 'InitiateCheckout', tt: 'InitiateCheckout', ga: 'begin_checkout' },
    package_select: { fb: 'CustomizeProduct', tt: 'ClickButton', ga: 'select_item' },
    demo_generated: { fb: 'ViewContent', tt: 'ViewContent', ga: 'view_item' }
  };
  RF.track = function (name, data) {
    data = data || {};
    try {
      document.dispatchEvent(new CustomEvent('rf:track', { detail: { name: name, data: data } }));
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'rf_' + name }, data));
      var std = STANDARD[name];
      if (window.fbq) std ? window.fbq('track', std.fb, data) : window.fbq('trackCustom', 'rf_' + name, data);
      if (window.ttq && window.ttq.track) window.ttq.track(std ? std.tt : 'rf_' + name, data);
      if (window.gtag) window.gtag('event', std ? std.ga : 'rf_' + name, data);
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('rf_' + name, data);
      if (RF.cfg.debug) console.log('[rf:track]', name, data);
    } catch (e) { /* analiza nu are voie să strice pagina */ }
  };

  /* ------------------------------------------------------------ utilitare */
  RF.formatMoney = function (cents, format) {
    var value = (Number(cents) || 0) / 100;
    var whole = Math.round(value) === value;
    var fixed = whole ? String(value) : value.toFixed(2);
    function group(str, thousands, decimal) {
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var out = String(format || '{{amount_with_comma_separator}} lei').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key.indexOf('comma_separator') !== -1) return group(fixed, '.', ',');
      if (key.indexOf('no_decimals') !== -1) return group(String(Math.round(value)), ',', '.');
      return group(fixed, ',', '.');
    });
    return out.replace(/<[^>]+>/g, '');
  };

  RF.uid = function () {
    var key = 'rf_visitor', id = null;
    try { id = localStorage.getItem(key); } catch (e) {}
    if (!id) {
      id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
      try { localStorage.setItem(key, id); } catch (e) {}
    }
    return id;
  };

  RF.store = {
    get: function (key, fallback) {
      try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
    },
    set: function (key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} },
    del: function (key) { try { localStorage.removeItem(key); } catch (e) {} }
  };

  /* Micșorează o fotografie în browser înainte de urcare (o poză de telefon are 5–12 MB). */
  RF.shrinkImage = function (file, maxSide, quality) {
    maxSide = maxSide || 3000;
    return new Promise(function (resolve, reject) {
      if (!file || !/^image\//.test(file.type || 'image/')) return reject(new Error('not-image'));
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
        var w = Math.round(img.naturalWidth * scale), h = Math.round(img.naturalHeight * scale);
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        URL.revokeObjectURL(url);
        canvas.toBlob(function (blob) {
          blob ? resolve({ blob: blob, width: w, height: h, canvas: canvas }) : reject(new Error('encode'));
        }, 'image/jpeg', quality || 0.9);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      img.src = url;
    });
  };

  RF.thumb = function (canvas, side) {
    var scale = Math.min(1, (side || 320) / Math.max(canvas.width, canvas.height));
    var c = document.createElement('canvas');
    c.width = Math.round(canvas.width * scale); c.height = Math.round(canvas.height * scale);
    c.getContext('2d').drawImage(canvas, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', 0.72);
  };

  RF.api = function (path, options) {
    options = options || {};
    var base = (RF.cfg.api || '').replace(/\/+$/, '');
    if (!base) return Promise.reject(Object.assign(new Error('no-api'), { code: 'no-api' }));
    return fetch(base + path, options).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        if (!res.ok) throw Object.assign(new Error(body.error || 'http-' + res.status), { code: body.error, status: res.status, body: body });
        return body;
      });
    });
  };

  /* ------------------------------------------------- pornirea componentelor */
  var inits = [];
  RF.register = function (fn) { inits.push(fn); if (started) fn(document); };
  var started = false;

  function reveal(root) {
    var els = root.querySelectorAll('[data-rf-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || RF.reducedMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function links(root) {
    root.querySelectorAll('[data-rf-scroll]:not([data-rf-bound])').forEach(function (a) {
      a.setAttribute('data-rf-bound', '');
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        var service = a.getAttribute('data-rf-service');
        if (service) document.dispatchEvent(new CustomEvent('rf:service', { detail: { service: service } }));
        RF.scrollTo(target);
      });
    });
    root.querySelectorAll('[data-rf-track]:not([data-rf-tracked])').forEach(function (el) {
      el.setAttribute('data-rf-tracked', '');
      el.addEventListener('click', function () {
        RF.track(el.getAttribute('data-rf-track'), { place: el.getAttribute('data-rf-track-place') || '' });
      });
    });
  }

  function gallery(root) {
    root.querySelectorAll('[data-rf-gallery]:not([data-rf-bound])').forEach(function (sec) {
      sec.setAttribute('data-rf-bound', '');
      var chips = sec.querySelectorAll('[data-rf-filter]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var cat = chip.getAttribute('data-rf-filter');
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-on', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          sec.querySelectorAll('[data-rf-cat]').forEach(function (item) {
            item.classList.toggle('is-hidden', cat !== '*' && item.getAttribute('data-rf-cat') !== cat);
            item.classList.add('is-in');
          });
        });
      });
    });
  }

  function header() {
    var el = document.querySelector('[data-rf-header]');
    if (!el || el.hasAttribute('data-rf-bound')) return;
    el.setAttribute('data-rf-bound', '');
    var update = function () { el.classList.toggle('is-scrolled', RF.scrollTop() > 8); };
    RF.onScroll(update);
    update();
  }

  // Butonul lipit: vizibil doar când niciuna dintre zonele din data-hide-on nu e pe ecran.
  function sticky(root) {
    root.querySelectorAll('[data-rf-sticky]:not([data-rf-bound])').forEach(function (bar) {
      bar.setAttribute('data-rf-bound', '');
      if (!('IntersectionObserver' in window)) return;
      var visible = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target);
        });
        var on = visible.size === 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        var link = bar.querySelector('a');
        if (link) link.tabIndex = on ? 0 : -1;
      }, { rootMargin: '-10% 0px -10% 0px' });
      (bar.getAttribute('data-hide-on') || '').split(',').forEach(function (sel) {
        sel = sel.trim();
        if (!sel) return;
        try { document.querySelectorAll(sel).forEach(function (el) { io.observe(el); }); } catch (e) {}
      });
    });
  }

  function boot(root) {
    reveal(root); links(root); gallery(root); sticky(root); header();
    inits.forEach(function (fn) { try { fn(root); } catch (e) { if (RF.cfg.debug) console.error(e); } });
  }

  function start() { started = true; boot(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // editorul de teme Shopify reîncarcă secțiunile una câte una
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
